module.exports = { raw: '9.6.1' };



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 11
// module chunks = 0 1